// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__wOdrU","hover":"Link_hover__k_m_n","underline":"Link_underline__fjaPs"};